// extracted by mini-css-extract-plugin
export default {"agentsPage":"styles_agentsPage__flYR-","cards":"styles_cards__r4kpi","search":"styles_search__EuT26","datatable":"styles_datatable__jy7WZ","table":"styles_table__B9SfK"};